import React from 'react';
import {
  Box,
  Container,
  Grid,
  makeStyles,
  Slider,
  withStyles,
} from '@material-ui/core';
import InputField from '../inputField/InputField';
import Question from '../question/Question';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    marginTop: 50,
  },
  question: {
    marginTop: 20,
  },
  slider: {
    width: window.innerWidth < 350 ? 250 : 320,
  },
  inputWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  input: {
    width: 42,
  },
});

const PrettySlider = withStyles({
  root: {
    color: 'lightgrey',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: props =>
      props.hovercolor == undefined ? '#4287f5' : props.hovercolor,
    border: props =>
      props.hovercolor == undefined
        ? '3px solid #4287f5'
        : '3px solid  ' + props.hovercolor,
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },

  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
    backgroundColor: props =>
      props.hovercolor == undefined ? '#4287f5' : props.hovercolor,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const marks = [
  {
    value: 0,
    label: <span></span>,
  },
  {
    value: 1000,
    label: <span></span>,
  },
];

const SliderInput = ({
  questionNo,
  questionText,
  description,
  selectedValue,
  handleChange,
  handleChangex,
  beschreibung,
  minmax,
  hovercolor,
}) => {
  const classes = useStyles(hovercolor);

  const handleSliderChange = (e, value) => {
    handleChange(value);
  };

  const handleInputChange = e => {
    handleChange(parseInt(e.target.value));
  };

  const handleBlurChange = e => {
    handleChangex(parseInt(e.target.value));
  };
  return (
    <div className=" h-full flex flex-col justify-between" id="slidercard">
      <div className="text-center mt-40px">
        <Question
          questionNo={questionNo}
          questionText={questionText}
          description={description}
        />
      </div>
      <div className="text-center ">
        <PrettySlider
          className={classes.slider}
          id="inputPrettySlider"
          value={selectedValue}
          onChange={handleSliderChange}
          aria-labelledby="input-slider"
          marks={marks}
          min={minmax ? minmax[0] : 0}
          max={minmax ? minmax[1] : 1000}
          hovercolor={hovercolor}
        />
      </div>

      <div className="mb-40px text-center">
        {' '}
        <InputField
          label={beschreibung != undefined ? beschreibung : 'Anzahl'}
          id="inputSliderCard"
          type="number"
          className={classes.input}
          value={selectedValue}
          margin="dense"
          onChange={handleInputChange}
          onBlur={handleBlurChange}
          placeholder={
            beschreibung != undefined ? beschreibung : 'Fläche in m²'
          }
          inputProps={{
            step: 10,
            min: 0,
            max: 1000,
            type: 'number',
            'aria-labelledby': 'input-slider',
          }}
        />
      </div>
    </div>
  );
};

const Slidercard = ({ daten, cardcontent, handleUpdate, hovercolor }) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  let maxh =
    cardcontent['minmax'] != undefined
      ? parseInt(
          (parseInt(cardcontent['minmax'][1]) -
            parseInt(cardcontent['minmax'][0])) /
            2
        ) + parseInt(cardcontent['minmax'][0])
      : 0;

  if (cardcontent['selectionx'] != undefined) {
    maxh = parseInt(cardcontent['selectionx']);
  }

  'selection' in daten['info'][cardID]
    ? 0
    : (daten['info'][cardID]['selection'] = maxh);

  const handleChange = value => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists

    daten['info'][cardID]['selection'] = value;
    handleUpdate(daten);
  };

  const handleChangex = value => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    if (cardcontent['minmax'] != undefined) {
      if (value < parseInt(cardcontent['minmax'][0])) {
        value = parseInt(cardcontent['minmax'][0]);
      }
      if (value > parseInt(cardcontent['minmax'][1])) {
        value = parseInt(cardcontent['minmax'][1]);
      }
    }
    if (isNaN(value)) {
      value = parseInt(cardcontent['minmax'][0]);
    }
    daten['info'][cardID]['selection'] = value;
    handleUpdate(daten);
  };

  return (
    <SliderInput
      questionNo={step}
      questionText={cardcontent['headline']}
      selectedValue={daten['info'][cardID]['selection']}
      handleChange={e => handleChange(e)}
      handleChangex={e => handleChangex(e)}
      beschreibung={cardcontent['beschreibung']}
      minmax={cardcontent['minmax']}
      hovercolor={hovercolor}
    />
  );
};

export default Slidercard;
